<div *ngIf="user.email" class="d-flex align-items-center header">
  <a class="logo position-relative" routerLink="/" data-id="root-logo" showBuildVersionOnHover>
    <ng-container *featureToggleOn="RdrFeature.xmas">
      <img class="image" src="/assets/svg/logo-xmas.svg" />
    </ng-container>

    <ng-container *featureToggleOff="RdrFeature.xmas">
      <img class="image" src="/assets/svg/logo.svg" />
    </ng-container>

    <typography-v2 *ngIf="env" class="text-white position-absolute env" look="small">{{
      env
    }}</typography-v2>
  </a>

  <div class="d-flex me-auto align-items-center">
    <ng-container *ngFor="let item of links">
      @if (item.navKey === pipelineNavKey && pipelineBoards.length) {
        <dropdown-v2
          #pipelineDropdown
          buttonType="header"
          [compact]="true"
          [customListTemplate]="pipelineBoardsTemplate"
          iconColor="var(--color-white-50)"
          [items]="pipelineBoards"
          [class.active]="pipelineChildActive"
          class="pipeline-navigation"
          data-id="pipeline-navigation"
          look="link"
          [placeholder]="pipelineLabel"
        />

        <ng-template #pipelineBoardsTemplate let-items="items">
          <div class="pipeline-links">
            <a
              *ngFor="let board of items"
              (click)="pipelineDropdown.toggleCollapsed()"
              [attr.data-id]="board.label | toDataID"
              [class.active]="board.path === activeBoardPath"
              [routerLink]="board.path"
            >
              <typography-v2 look="caption-bold">{{ board.label }}</typography-v2>
            </a>
          </div>
        </ng-template>
      } @else {
        <ng-container *ngTemplateOutlet="linkTemplate; context: { item }" />
      }
    </ng-container>

    <ng-container *ngIf="adminLinks.length">
      <dropdown-v2
        #adminDropdown
        buttonType="header"
        [compact]="true"
        [customListTemplate]="adminLinksTemplate"
        iconColor="var(--color-white-50)"
        [items]="adminLinks"
        [class.active]="adminChildActive"
        class="admin-navigation"
        data-id="admin-navigation"
        look="link"
        [placeholder]="adminLabel"
      />

      <ng-template #adminLinksTemplate let-items="items">
        <div class="admin-links">
          <a
            *ngFor="let item of items"
            (click)="adminDropdown.toggleCollapsed()"
            [attr.data-id]="item.label | toDataID"
            [queryParams]="item.queryParams"
            [routerLink]="item.link"
            [routerLinkActiveOptions]="{ exact: false }"
            routerLinkActive="active"
          >
            <typography-v2 look="caption-bold">{{ item.label }}</typography-v2>
          </a>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #linkTemplate let-item="item">
      <a
        [routerLink]="item.link"
        [attr.data-id]="item.label | toDataID"
        [queryParams]="item.queryParams"
        [routerLinkActiveOptions]="{ exact: false }"
        routerLinkActive
        #link="routerLinkActive"
      >
        <button-v2 type="header" look="link" [pressed]="link.isActive">
          <typography-v2 look="caption-bold">{{ item.label }}</typography-v2>
        </button-v2>
      </a>
    </ng-template>
  </div>

  <global-search *ngIf="canUseGlobalSearch"></global-search>

  <alerts class="v2-ml-1"></alerts>

  <user-navbar [contentTemplate]="contentTemplate" [user]="user" class="v2-ml-1 navbar" />

  <ng-template #contentTemplate>
    <ng-container *featureToggleOn="RdrFeature.lead_boost">
      <ng-container *ngTemplateOutlet="leadBoostTemplate"></ng-container>

      <hr class="v2-mb-2" />
    </ng-container>

    <dropdown-item-v2
      *ngIf="(user.isActive && (user.superadmin || user.isDev)) || user.isSuperadminContext"
      (click)="goToProfile()"
      class="text-black v2-px-5"
      id="profile"
      hoverClass
    >
      <rdr-svg-icon key="user" class="v2-mr-2"></rdr-svg-icon>
      Profile
    </dropdown-item-v2>

    <dropdown-item-v2
      (click)="photoUpload.click()"
      class="text-black v2-px-5"
      id="photo"
      hoverClass
    >
      <rdr-svg-icon key="photo-badge-plus" class="v2-mr-2"></rdr-svg-icon>
      Upload Photo
    </dropdown-item-v2>

    <dropdown-item-v2
      *ngIf="canManageAgentSubstitution"
      (click)="openSubstitutionModal()"
      class="text-black v2-px-5"
      hoverClass
    >
      <rdr-svg-icon key="change" class="v2-mr-2"></rdr-svg-icon>
      Coverage
    </dropdown-item-v2>

    <dropdown-item-v2 (click)="logout()" class="text-black v2-px-5" id="logout" hoverClass>
      <rdr-svg-icon key="rectangle-portrait-and-arrow-right" class="v2-mr-2"></rdr-svg-icon>
      Logout
    </dropdown-item-v2>

    <ng-container *featureToggleOn="RdrFeature.lead_boost_teamlead">
      <ng-container *ngTemplateOutlet="leadBoostTeamleadTemplate"></ng-container>
    </ng-container>
  </ng-template>

  <loading-overlay *ngIf="loading$ | async"></loading-overlay>
</div>

<input (change)="setPhoto($event)" #photoUpload type="file" class="d-none" />

<ng-template #substitutionModalTpl>
  <modal-v2 header="Set Up Coverage">
    <team-lead-substitution-form *ngIf="canManageTeamSubstitution" />
    <agent-substitution-form *ngIf="!canManageTeamSubstitution" />
  </modal-v2>
</ng-template>

<ng-template #leadBoostTemplate>
  @let agentStatus = agentStatus$ | async;

  <dropdown-item-v2
    (click)="$event.stopPropagation()"
    class="d-flex align-items-start justify-content-between lead-item v2-px-5 v2-pb-4 v2-pt-2"
  >
    <div class="d-flex flex-column">
      <typography-v2 class="text-black">
        Lead Alert: <b data-id="active">{{ agentStatus?.isActive ? 'Active' : 'Away' }}</b>
      </typography-v2>

      <typography-v2 class="text-black v2-mt-1"
        >Active agents:
        <b data-id="active-agents">{{ activeLeadBoostUserCount$ | async }}</b></typography-v2
      >
    </div>

    <switch-button
      (check)="setAgentAvailability(!agentStatus?.isActive)"
      [checked]="!!agentStatus?.isActive"
      [disabled]="!agentStatus?.canToggle"
    />
  </dropdown-item-v2>

  <ng-container *ngIf="agentStatus?.awayUntil | minutesRemaining as minutesRemaining">
    <lead-boost-pause *ngIf="minutesRemaining" [minutesRemaining]="minutesRemaining" />
  </ng-container>
</ng-template>

<ng-template #leadBoostTeamleadTemplate>
  <ng-container *ngIf="teamMembersStatuses$ | async as teamMembersStatuses">
    @if (teamMembersStatuses.away?.length || teamMembersStatuses.active?.length) {
      <hr class="v2-mt-2" />

      <div class="d-flex flex-column v2-mx-5 text-black g-4 v2-py-4 users-list">
        @if (teamMembersStatuses.away?.length) {
          <typography-v2 look="text-semibold">Away</typography-v2>

          <ng-container
            *ngTemplateOutlet="
              userlistTemplate;
              context: { users: teamMembersStatuses.away, statusChangedReason: true }
            "
          />

          @if (teamMembersStatuses.active?.length) {
            <hr />
          }
        }
        @if (teamMembersStatuses.active?.length) {
          <typography-v2 look="text-semibold">Active</typography-v2>

          <ng-container
            *ngTemplateOutlet="userlistTemplate; context: { users: teamMembersStatuses.active }"
          />
        }
      </div>
    }
  </ng-container>

  <ng-template #userlistTemplate let-users="users" let-statusChangedReason="statusChangedReason">
    <div *ngIf="users?.length" class="d-flex flex-column g-3">
      <div *ngFor="let user of users" class="d-flex align-items-center justify-content-between">
        @let agent = { picture: user.picture, fullName: user.fullName, id: '' };
        <agent-card [agent]="agent" />

        <div class="d-flex align-items-center text-jazlyn-700 v2-ml-2">
          <typography-v2 *ngIf="statusChangedReason">
            {{ user.statusChangedReason | label }}&nbsp;
          </typography-v2>

          <typography-v2>{{ user.statusChangedAt | createdAt }}</typography-v2>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
